module.exports = __webpack_public_path__ + "img/star_ptrn.3e347250.svg";